/** Shared search UI copy — use on every experience search bar. */
export const SEARCH_PLACEHOLDER = 'Looking for something?';

export const SEARCH_EMPTY_MESSAGE =
  "No exact matches yet. Try describing what you're looking for differently, or search by device, vibe, location, or experience type.";

/** Minimum relevance score to include a result (allows strong partial matches). */
export const DEFAULT_MIN_SCORE = 3;
